var link_preview_default = {
  "fontElementMap": "a2ePK",
  "linkPreview": "_93rYT",
  "linkPreviewImage": "GMuWq",
  "linkPreviewInfo": "zPJpV",
  "linkPreviewTitle": "XFSwg",
  "ellipsis": "_6h3DY",
  "linkPreviewDescription": "fA3Ya",
  "linkPreviewUrl": "_69XRH"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
